import { SearchFormState } from '../reducers';

export const hasPromoCode = (state: SearchFormState) => !!state.promoCode;
export const getPromoCode = (state: SearchFormState) => state.promoCode;
